import React, { useState, useEffect } from 'react'
import { fetchLocalElectionTimer } from '../../../services/local-election.service';
import LocalElection from '../../../models/local-election.model';
import { lang } from '../../../config/app.config';
import { Tooltip, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';



const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#F90026',
    color: 'white',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(18),
    border: '1px solid #F90026',
  },
}))(Tooltip);


const LocalElectionTimer = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [leData, setLeData] = useState<LocalElection | undefined>();

  useEffect(() => {
    fetchLEData();
  }, [])

  const fetchLEData = async () => {
    setLoading(true);
    const data = await fetchLocalElectionTimer();
    console.log('data here', data)
    setLeData(data);
    setLoading(false);
  }

  let daysToGo = leData?.election_deadline_days ? leData?.election_deadline_days[lang === 'np' ? 'value_np' : 'value_en'] : 0;
  console.log('days to go', daysToGo)

  return (
    <>
      {leData?.election_deadline_switch ?
        <>
          {
            loading ? "" :
              <div className="display-flex info-icon-list local-election" style={{}}>
                <h3>{leData?.election_deadline_title[lang === 'np' ? 'value_np' : 'value_en'] ?? 'Local Election'}</h3>
                {(daysToGo == 0 || daysToGo == '०') ?
                  <></>
                  :
                  <div className="display-flex">
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">{leData?.election_deadline_date ? leData?.election_deadline_date[lang === 'np' ? 'value_np' : 'value_en'] : '2022-05-13'}</Typography>
                        </React.Fragment>
                      }
                    >
                      <div className='local-election--timer'>
                        <h1>{daysToGo}</h1>
                      </div>
                    </HtmlTooltip>
                    <h4>{leData?.election_deadline_subtitle[lang === 'np' ? 'value_np' : 'value_en'] ?? 'days to go'}</h4>
                  </div>
                }
              </div>
          }
        </>
        : <></>}
    </>
  )
}

export default LocalElectionTimer
